import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem("TOKEN"),
  },
  getters: {},
  mutations: {
    // 修改token
    setToken(state, data) {
      //把仓库里的token修改
      state.token = data;
      //把token存储到本地
      sessionStorage.setItem("TOKEN", JSON.stringify(token));
    },
  },
  actions: {},
  modules: {},
});
